import {Grid, useTheme} from "@mui/material";
import React from "react";
import DealMenu from "../components/DealMenu";
import {Item} from "../../../domains/common/components/Item";
import RealtyFormContainer from "../components/Realty";
import {RolesEnums} from "../../../enums";
import {FilesListContainer} from "../components/FilesContainer";
import {XmlList} from "../components/XmlList";
import {Responsible} from "../components/Responsible";
import FormSelect from "../../../domains/common/components/FormSelect";
import {agreementTypesSelect} from "../../../dictionaries";
import DealCommentContainer from "../components/Comment";
import {Title5} from "../../../domains/common/components/Typography";
import {DealParamsMortgageAndExpress} from "../components/DealParams";
import {dealData} from "../deal";
import {ParticipantsComponent} from "../components/Participants";
import { ChildStatmentContainer } from "../components/ChildStatement";

// Регистрация ДДУ
export function DealShareRegistrationContainer() {
  const theme = useTheme();

  return (
    <Grid container spacing={1} sx={{mt: 0.2}}>
      <Grid item xs={12}>
        <DealMenu dealId={dealData.dealId}></DealMenu>
      </Grid>
      <Grid item xs={12}>
        <Item sx={{backgroundColor: theme.palette.background.default}}>
          <RealtyFormContainer values={dealData.realty}/>
        </Item>
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <ParticipantsComponent role={RolesEnums.DEVELOPER}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <FilesListContainer/>
                </Item>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <XmlList value={dealData.dealXmlStatementsList}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <Responsible value={dealData.user}/>
            </Item>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Item sx={{backgroundColor: theme.palette.background.default}}>
              <ParticipantsComponent role={RolesEnums.SHAREHOLDER}/>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <ParticipantsComponent role={RolesEnums.REPRESENTATIVE}/>
                </Item>
              </Grid>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <ParticipantsComponent role={RolesEnums.EXT_SIGNER}/>
                </Item>
              </Grid >
              <Grid item xs={12}>
                <ChildStatmentContainer />
              </Grid>
              <Grid item xs={12}>
                <Item sx={{backgroundColor: theme.palette.background.default}}>
                  <DealCommentContainer />
                </Item>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function ShareAddParamsContainer({onChange}) {
  const handleStatmentTypeChange = (e) => {
    onChange ? onChange({agreementType: e.target.value}) : void 0
  }

  return (
    <Grid container>
      <Grid item xs={6}>
            <Title5 title="Тип договора"/>
            <FormSelect name="agreementType"
                        data={agreementTypesSelect} minWidth={250}
                        maxWidth={450} value={dealData?.deal?.agreementType}
                        onChange={handleStatmentTypeChange}/>
      </Grid>
      <Grid item xs={6}>
        <DealParamsMortgageAndExpress dealData={dealData} onChange={onChange} />
      </Grid>
    </Grid>
  )
}